import { ErrorBoundary } from 'components/common/error-boundary';
import { FeatureDemoMenubar } from 'components/sections/feature-demo/inputs/menubar';
import { FeatureDemoMultiSelect } from 'components/sections/feature-demo/inputs/multiselect';
import { FeatureDemoSlider } from 'components/sections/feature-demo/inputs/slider';
import { FeatureDemoSwitchButton } from 'components/sections/feature-demo/inputs/switch-button';
import { FeatureDemoTextfields } from 'components/sections/feature-demo/inputs/textfields';
import { SubSectionBox } from 'components/sections/feature-demo/sub-section-box';

export const InputsDemo = () => {
  return (
    <ErrorBoundary identifier="InputsDemo">
      <SubSectionBox title="Menu Bar" source="common/menu-bar">
        <FeatureDemoMenubar />
      </SubSectionBox>

      <SubSectionBox title="Multiselect" source="common/form/multiselect">
        <FeatureDemoMultiSelect />
      </SubSectionBox>

      <SubSectionBox title="Slider" source="common/form/slider">
        <FeatureDemoSlider />
      </SubSectionBox>

      <SubSectionBox
        title="Switch Button"
        source="common/buttons/switch-button"
      >
        <FeatureDemoSwitchButton />
      </SubSectionBox>

      <SubSectionBox title="Regex Textfields" source="common/form/text">
        <FeatureDemoTextfields />
      </SubSectionBox>
    </ErrorBoundary>
  );
};
